module.exports = __webpack_public_path__ + "static/media/preventivo_verde.a9dbcae7.svg";